<div class="d-flex align-items-center">
  <input type="radio" class="my-0" [name]="name" [id]="innerId" [value]="value" [ngModel]="val"
    (ngModelChange)="onChange($event)" [checked]="value === val" />
  <label class="form-check-label cursor-pointer fw-normal my-0 ps-3" [for]="innerId">{{ label }}</label>
</div>